export default __webpack_public_path__ + "images/54d05d300cd0830bc2d6496fa4107325.png";